/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveOverlapEligibilityRequest": {
                "fields": {
                  "squareMerchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveOverlapEligibilityResponse": {
                "fields": {
                  "isEligibleForOverlap": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveOverlapEligibilityRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveOverlapEligibilityResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveOverlapEligibilityRequest @ squareup/corporate_card/service/retrieve_overlap_eligibility.proto at 8:1
 */
export const RetrieveOverlapEligibilityRequest = $root.lookupType('squareup.corporate_card.service.RetrieveOverlapEligibilityRequest');
fixType(RetrieveOverlapEligibilityRequest, {
  squareMerchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveOverlapEligibilityRequest);
/**
 * SOURCE RetrieveOverlapEligibilityResponse @ squareup/corporate_card/service/retrieve_overlap_eligibility.proto at 15:1
 */
export const RetrieveOverlapEligibilityResponse = $root.lookupType('squareup.corporate_card.service.RetrieveOverlapEligibilityResponse');
fixType(RetrieveOverlapEligibilityResponse);
Builder.createAndAttachToType(RetrieveOverlapEligibilityResponse);